// extracted by mini-css-extract-plugin
module.exports = {"divider":"VerificationLabel__divider___TNJi8","verify":"VerificationLabel__verify___Z6fGi"};